"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeletedOffer = DeletedOffer;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const styled_breakpoints_1 = require("styled-breakpoints");
const icons_1 = require("@ant-design/icons");
const react_intl_1 = require("react-intl");
const react_router_1 = require("react-router");
const elements_1 = require("@src/components/elements");
const slug_offer_1 = __importDefault(require("@src/shared/slug-offer"));
const useSalaryFormatter_1 = require("@src/hooks/useSalaryFormatter");
const SeparatorStyled = (0, styled_components_1.default)(elements_1.Separator) `
	align-self: center;
	width: 50%;
	min-width: 50%;
`;
const RemovedOfferImageStyled = styled_components_1.default.img `
	align-self: center;
	width: 200px;
	height: 200px;
`;
const DeletedOfferSuggestedOffer = styled_components_1.default.div `
	margin-top: 1.5rem;
	max-width: 300px;
	width: 300px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;

	${(0, styled_breakpoints_1.down)('sm')} {
		margin-top: 2rem;
		width: 100%;
	}
`;
const DeletedOfferSuggestedOffers = styled_components_1.default.div `
	display: flex;
	justify-content: space-around;

	${(0, styled_breakpoints_1.down)('sm')} {
		flex-direction: column;
		align-items: center;
	}
`;
function DeletedOffer({ similarOffers = [] }) {
    const history = (0, react_router_1.useHistory)();
    const { formatSalary } = (0, useSalaryFormatter_1.useSalaryFormatter)();
    const showSimilarOffers = similarOffers.length > 0;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(elements_1.Panel, { className: "flex-col p-t-l p-b-xl", children: [(0, jsx_runtime_1.jsx)("h1", { className: "m-b-l font-size-xxxl text-center", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.offer_was_removed" }) }), (0, jsx_runtime_1.jsx)(RemovedOfferImageStyled, { src: "/media/illustrations/streamline-icon-clipboard-subtract.svg", alt: "Removed" }), showSimilarOffers && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h3", { className: "m-t-l font-size-l text-center", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.we_picked_similar_offers" }) }), (0, jsx_runtime_1.jsx)(SeparatorStyled, {}), (0, jsx_runtime_1.jsx)(DeletedOfferSuggestedOffers, { children: similarOffers.map(o => {
                                var _a;
                                const slug = new slug_offer_1.default({ text: o.title });
                                return ((0, jsx_runtime_1.jsxs)(DeletedOfferSuggestedOffer, { children: [(0, jsx_runtime_1.jsx)("div", { className: "font-size-l m-b-m", children: o.title }), (0, jsx_runtime_1.jsx)(elements_1.Tag, { className: "m-b-xs flex-row align-center", color: "magenta", icon: (0, jsx_runtime_1.jsx)(elements_1.Icon, { style: { width: '0.75rem' }, className: "icon", type: "maps-pin" }), children: (_a = o.address) === null || _a === void 0 ? void 0 : _a.city }), Boolean(Number(o.is_paid)) && ((0, jsx_runtime_1.jsx)(elements_1.Tag, { className: "flex-row align-center", color: "green", icon: (0, jsx_runtime_1.jsx)(icons_1.EuroOutlined, {}), children: formatSalary({
                                                rate: o.salary_rate,
                                                amountFrom: o.salary_amount_from,
                                                amountTo: o.salary_amount_to,
                                                currency: o.salary_currency,
                                                salaryType: o.salaryType,
                                            }) })), (0, jsx_runtime_1.jsxs)(elements_1.Button, { className: "m-t-m", link: `/ponuka/${slug}-${o.id}`, size: "middle", children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.details.more_details" }), (0, jsx_runtime_1.jsx)(icons_1.ArrowRightOutlined, { className: "m-l-s" })] })] }));
                            }) })] })), !showSimilarOffers && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h3", { className: "m-t-l font-size-l text-center", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.position_no_longer_available" }) }), (0, jsx_runtime_1.jsx)(SeparatorStyled, {}), (0, jsx_runtime_1.jsx)("div", { className: "flex-row justify-space-around", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { type: "primary", onClick: () => history.pushLocalized('/ponuky'), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.see_other_offers" }) }) })] }))] }) }));
}
